let lockCount = 0
const scrollLockClass = "lock-scroll"

export function lockBodyScroll() {
  lockCount++
  if (lockCount === 1) {
    document.body.classList.add(scrollLockClass)
  }
}

export function unlockBodyScroll() {
  lockCount--
  if (lockCount < 0) {
    lockCount = 0
  }

  if (lockCount === 0) {
    document.body.classList.remove(scrollLockClass)
  }
}

export function resetBodyScrollLock() {
  lockCount = 0
  document.body.classList.remove(scrollLockClass)
}
